import React, { Component } from 'react';
import infeedo from '../../../static/images/infeedo.svg'
import classnames from 'classnames';
import { Link } from "gatsby";
import config from '../../../config';
import { looseFocus } from '../../helper/looseFocus';
import ScheduleDemoButton from '../scheduleDemo/ScheduleDemoButton';
import { globalHistory } from "@reach/router";
import queryString from 'query-string';
import {jwtVerifyAndDecode} from '../../helper/verifyToken';
import white_cross_btn from '../../../static/images/close-icon-white.png'
// import '../../css/header.css'

//for future reference
//import DropdownMenu from './header-dropdown-menu'
//import Countdown from 'react-countdown-now';



const header_section_left = [

    {
        name: 'Customers',
        link: '/customers',
    },
    {
        name: 'Pricing',
        link: '/pricing',
    },
    {
        name: 'Resources',
        link: '/resources',
    },
    {
        name: 'Blog',
        anchor: 'https://blog.infeedo.com',
    },
    {
        name:'About / Jobs',
        anchor:'https://jobs.infeedo.com',
        
    }


]

const header_section_right = [
    {
        name: 'About / Jobs',
        anchor: 'https://jobs.infeedo.com',
        classes:'button is-white nav-button is-hidden-mobile'
    },
    {
        name: 'Login',
        anchor: `${config.home_url}/login/`,
        classes:'button is-link is-outlined nav-button is-fullwidth is-hidden-tablet'
    },
    {
        name: 'Login',
        anchor: `${config.home_url}/login/`,
        classes:'button is-white nav-button is-hidden-mobile'
    }
]


export default class Header extends Component {

    state = {
        is_active: false,
        event_added: false,
        current_path: '',
        trigger_tour: false,
        open_pink_banner: false,
        is_toggle_btn_clicked:false,
    }

    componentDidMount() {
        this.getActivePath();
        if (window.location.pathname === '/') {
            if (localStorage.token) {
                jwtVerifyAndDecode(localStorage.token).then((response) => {
                    window.location = `${config.beta_dashboard_url}/${localStorage.token}`
                }, () => {
                    localStorage.clear();
                    sessionStorage.clear();
                })
            }
        }
        this.setBannerStatus();
        const parsed = queryString.parse(window.location.search);
        if (parsed.open_form === "true") {
            this.setState({ trigger_tour: true });
        }
    }

    setBannerStatus = () => {

        if (sessionStorage.open_pink_banner || window.location.pathname.includes('/roi-calculator')) {
            this.setState({
                open_pink_banner: false
            })
        }
        else {
            this.setState({
                open_pink_banner: true
            })
        }
    }

    getActivePath = () => {
        const current_path = globalHistory.location.pathname;
        this.setState({ current_path });
    }

    toggleNav = () => {
        const { is_active} = this.state;
        if (is_active) {
            this.closeNav();
        }
        looseFocus();
        this.setState({ is_active: true,is_toggle_btn_clicked:true}, () => this.addEventListener());
    }

    addEventListener = () => {
        const { is_active} = this.state;
        if (is_active) {
            document.body.addEventListener("click", this.closeNav);
            
            this.setState({ event_added: true });
        }
    }

    openNav = () => {
        this.setState({ is_active: true });
    }

    closeNav = () => {
        const{is_toggle_btn_clicked}=this.state;
        if(!is_toggle_btn_clicked){
            document.body.removeEventListener('click', this.closeNav);
            this.setState({ is_active: false});
        }
        this.setState({is_toggle_btn_clicked:false});
    }

    closePinkBanner = () => {
        sessionStorage.setItem('open_pink_banner', true);
        this.setBannerStatus();
    }


    renderNavStart = (page) => header_section_left.map(info => {
        if(page === 'customers'){
            return null;
        }
        else if(page === 'pricing'){
            if(info.link === '/pricing'){
                return (
                    <Link to={'/pricing'} className={classnames('navbar-item', { 'is-active': this.state.current_path.includes(info.name.toLowerCase())})}>
                        {'Pricing'}
                    </Link>
                )
            }
            else{
                return null;
            }
        }
        else if(page === 'resources'){
            if(info.link === '/resources'){
                return (
                    <Link to={'/resources'} className={classnames('navbar-item', { 'is-active': this.state.current_path.includes(info.name.toLowerCase())})}>
                        {'Resources'}
                    </Link>
                )
            }
            else{
                return null;
            }
        }
        else if (info.link) {
            return (
                <Link to={info.link} className={classnames('navbar-item', { 'is-active': this.state.current_path.includes(info.name.toLowerCase())})}>
                    {info.name}
                </Link>
            )
        }else{
            if(info.name === 'About / Jobs'){
                return(
                <a href={info.anchor} target="_blank" rel="noopener noreferrer" className="navbar-item is-hidden-tablet">
                    {info.name}
                </a>
                )
            }else{
                return (
                    <a href={info.anchor} target="_blank" rel="noopener noreferrer" className="navbar-item">
                        {info.name}
                    </a>
                )
            }
        }

    })

    renderNavEnd = () => header_section_right.map(info => {
        if (info.anchor) {
            return (
                <a href={info.anchor} target="_blank" rel="noopener noreferrer" className={info.classes}>
                    {info.name}
                </a>
            )
        }
        else{
            return <></>
        }
    })


    RenderBanner = () => {
        return (
            <nav className="navbar is-fixed-top navbanner-padding banner-navbar " role="navigation" aria-label="main navigation" id="TopPinkBanner">
                <div className="initial-div">
                    {/* <img src={money_bag} className="banner-img is-hidden-mobile" alt="infeedo logo white"></img> */}
                    <p className="navbar-text is-size-8-mobile " id="BannerText">[Released] Win the war of talent with the &nbsp; <span className='has-text-weight-semibold'>2022 Employee Experience Report.</span></p>
                    <button className="button banner-btn is-size-8-mobile is-size-6" onClick={event => window.open('https://ai.infeedo.com/hr-trends-2022-ind-ent')}>Download now!</button>
                    <div className="icon is-large is-hidden-desktop cross-icon  ">
                        <textbox  onClick={this.closePinkBanner}>
                        <img src={white_cross_btn} alt="close" className="banner-close-btn"/>
                        </textbox>
                    </div>
                </div>
                <div className="icon is-large is-hidden-touch  cross-icon">
                    <textbox onClick={this.closePinkBanner}>
                    <img src={white_cross_btn} className="banner-close-btn" alt="close" />
                    </textbox>
                </div>
            </nav>
        )
    }

    //code to render a countdown using Countdown library
    rendererDays = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <span></span>;
        } else if (days <= 1) {
            // Render a countdown\
            return <span><b>{days} day</b></span>
        }
        else {
            return <span> <b>{days} days</b></span>
        }
    };

    render() {
        const { open_pink_banner, is_active, trigger_tour } = this.state;
        const {page} = this.props;
        return (
            <header>
                <nav className="navbar is-fixed-top nav-padding" role="navigation" aria-label="main navigation">
                    <div className="navbar-brand">
                    <a target="_self" className="navbar-item" href="https://www.infeedo.ai/">
                        <img src={infeedo} width="112" height="28" className="navbar-logo" alt="infeedo" />
                    </a>
                        <div className="minimal-header">
                            <button onClick={this.toggleNav} className={classnames('navbar-burger no-mar-left no-border burger', { 'is-active': is_active })} aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
                                <span aria-hidden="true"></span>
                                <span aria-hidden="true"></span>
                                <span aria-hidden="true"></span>
                            </button>
                            <ScheduleDemoButton is_hidden_desktop={true} trigger_tour={trigger_tour} />
                        </div>
                        {is_active ? <div className="placeholder-btn"></div> : null}
                    </div>

                    <div id="navbarBasicExample" className={classnames('navbar-menu', { 'is-active': is_active })}>
                        {/* <DropdownMenu/> */}
                        <div className="navbar-start ">
                            {this.renderNavStart(this.props.page)}
                        </div>

                        <div className="navbar-end">
                            <div className="navbar-item">
                                <div className="buttons">
                                    {this.renderNavEnd()}
                                    {/* <ScheduleDemoButton is_fullwidth={true} is_hidden_tablet={true} classes="is-fullwidth is-hidden-tablet"/> */}
                                    <ScheduleDemoButton is_hidden_mobile={true} trigger_tour={trigger_tour} />
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>

                {/* {open_pink_banner ?
                    this.RenderBanner()
                    : null} */}
            </header>

        )
    }
}

//   